import { Form, Row, Col, Button } from "react-bootstrap";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  openModal,
  editModal,
  resetFormState,
  setSelectValidError,
} from "../../../../slices/common/reducer";
import { renderElement } from "../../../../Components/Common/FormRendererV2/Renderer";
import { RolesModalLayoutJSON } from "./Json/RolesLayoutJson";
import { createRole, updateRole } from "./RolesService";
import { setRolesEditID } from "../../../../slices/team/roles/rolesSlice";
import {
  getOrgId,
  getOrgType,
  getOrganizationType,
} from "../../../../Utils/CommonUtils";

const NewRoleModal = () => {
  const dispatch = useDispatch();
  const modalShow = useSelector((state) => state.common.modalShow);
  const edit = useSelector((state) => state.common.editShow);
  const formState = useSelector((state) => state.common.formRendererState);
  const RolesUpdateId = useSelector((state) => state.roles.rolesEdit.id);
  const rolesFieldJson = useSelector((state) => state.roles.rolesFieldJson);
  const orgType = getOrgType();
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const organizationId = selectedUser.organizationid;

  const handleClose = () => {
    dispatch(openModal(false));
    dispatch(editModal(false));
    dispatch(resetFormState());
    dispatch(setRolesEditID(null));
    dispatch(setSelectValidError(false));
  };

  const addNewClickHandler = (e) => {
    e.preventDefault();
    if (formState.status) {
      dispatch(setSelectValidError(false));
      createRole(formState, "ROL", orgType, organizationId);
    } else {
      dispatch(setSelectValidError(true));
    }
  };

  const updateClickHandler = (e) => {
    e.preventDefault();
    if (formState.status) {
      dispatch(setSelectValidError(false));
      updateRole(formState, RolesUpdateId, "ROL");
    } else {
      dispatch(setSelectValidError(true));
    }
  };

  return (
    <Modal
      isOpen={modalShow}
      onHide={() => handleClose()}
      centered
      backdrop="static"
      keyboard={false}
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={handleClose}
    >
      <Form
        className="tablelist-form"
        onSubmit={edit === false ? addNewClickHandler : updateClickHandler}
      >
        <ModalHeader className="p-3 bg-info-subtle" toggle={handleClose}>
          {edit ? "Update Role Details" : "Add New Role"}
        </ModalHeader>
        <ModalBody className="modal-body">
          <Row className="g-3">
            <Col lg={12}>
              {RolesModalLayoutJSON.map((element) => (
                <div key={element.elementid}>
                  {element.child.map((child) =>
                    renderElement(child, rolesFieldJson, formState)
                  )}
                </div>
              ))}
            </Col>
            <Col lg={12}>
              <div className="hstack gap-2 justify-content-end">
                {/* <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => handleClose(false)}
                >
                  Close
                </button> */}
                <Button
                  type="submit"
                  className="primary primary_button"
                  id="addNewMember"
                >
                  {edit ? "Update" : "Save"}
                </Button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Form>
    </Modal>
  );
};

export default NewRoleModal;
